import { isNil } from 'lodash';
import { API } from '@shared/types/api';

export function isNoCodeCard(card: API.CardFragment): boolean {
  return isNil(card.cardDefinitionId) && !isNil(card.workflowTemplateId);
}
